import { defineMessages } from 'react-intl';

export default defineMessages({
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ'
    },
    additionalEnrollment: {
        id: 'portal.index.Additional Enrollment',
        defaultMessage: 'Additional Enrollment'
    },
    claimList: {
        id: 'portal.index.Claims',
        defaultMessage: 'Claims'
    },
    claimDetails: {
        id: 'portal.index.Claim Details',
        defaultMessage: 'Claim Details'
    },
    createNote: {
        id: 'portal.index.Create Note',
        defaultMessage: 'Create Note'
    },
    policyDetails: {
        id: 'portal.index.Policy Details',
        defaultMessage: 'Policy Details'
    },
    accountInformation: {
        id: 'portal.index.Account Information',
        defaultMessage: 'Account Information'
    },
    homePage: {
        id: 'portal.index.Home Page',
        defaultMessage: 'Home Page'
    },
    updatePassword: {
        id: 'header.links.Update Password',
        defaultMessage: 'Update Password'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    },
    agentsignup: {
        id: 'portal.index.AgentSignup',
        defaultMessage: 'Users'
    },
    sessionExpired: {
        id: 'portal.sessionExpired',
        defaultMessage: 'Please refresh the page to start a new session'
    }
});
